/* file description */
// import { compose } from '@cui/corteza-js';
import { addOnlyModuleRecord } from './assetModel';
import { message } from 'antd';
import { TIP_MSG_MAP } from '@/components/SPTableWithModel/effect/consts';
// import { composeRecord } from '@/utils';

function toJSON(params: any) {
  const res: any[] = [];
  Object.keys(params).filter(key => key !== 'toJSON').forEach(key => {
    let value = params[key];
    if (_.isObject(value)) {
      value = value;
    } else if (value !== undefined && value !== null) {
      value = String(value);
    }
    res.push({
      name: key,
      value,
    });
  });
  return res;
}

export const addAssetModuleByRequest = async (FetchAPI: any, params: any) => {
  // const recordIns = new compose.Record(params.moduleInfo, params.values);
  // const recordIns = composeRecord(params.values);
  const info = {
    values: toJSON(params.values),
    records: [],
    labels: '{}',
    click: 'save',
  };
  try {
    const res = await addOnlyModuleRecord(FetchAPI, params.namespaceID, params.moduleID, info);
    if (res) {
      message.success(TIP_MSG_MAP.autoLineEditUpdateSuccess);
    }
    return res;
  } catch (e) {
    message.error(TIP_MSG_MAP.autoLineEditUpdateError);
    return {};
  }
};
